// src/utils/commandCenterApi.js
// Client for the SUPER_ADMIN Command Center endpoints. Mirrors src/utils/invoicingApi.js
// for the qs-building + apiInstance import. Both endpoints are GET-only (read-only, FR-002).
import apiInstance from './apiAuth';

const qs = (params = {}) => {
  // Drop empty values so the URL stays clean and the backend applies its defaults.
  const clean = {};
  Object.keys(params).forEach((k) => {
    const v = params[k];
    if (v !== undefined && v !== null && v !== '') clean[k] = v;
  });
  const q = new URLSearchParams(clean).toString();
  return q ? `?${q}` : '';
};

export const commandCenterApi = {
  // Single cached aggregation powering every widget (SC-003).
  getSummary: (params = {}) => apiInstance.get(`command-center/summary/${qs(params)}`),
  // Uncached drill-down; reconciles with the aggregate (SC-002/SC-005).
  getDeals: (params = {}) => apiInstance.get(`command-center/deals/${qs(params)}`),
};

export default commandCenterApi;
